/**
 * Where a spec sheet scan's job id is parked between screens.
 *
 * It exists because the read outlives the page: it carries on server-side
 * across a refresh, and a result that has already been paid for must not be
 * orphaned. The batch inbox leans on the same shelf for a different reason --
 * it hands a finished job to whichever bowler the operator sends it to, and
 * the review on that screen picks it up on mount without either side knowing
 * about the other.
 */

export const SCAN_JOB_KEY = "specsheet_scan_job";

export const rememberScanJob = (jobId) => {
  try {
    // Stamped now, not when the read started: recall treats an old stamp as
    // dead, and a job handed over from the inbox may have finished an hour
    // ago and still be perfectly good.
    localStorage.setItem(
      SCAN_JOB_KEY,
      JSON.stringify({ jobId, startedAt: Date.now() }),
    );
  } catch (e) {
    // Private mode or a full quota: losing the handoff is survivable.
  }
};

export const forgetScanJob = () => {
  try {
    localStorage.removeItem(SCAN_JOB_KEY);
  } catch (e) {}
};

export const recallScanJob = (maxAgeMs) => {
  try {
    const raw = localStorage.getItem(SCAN_JOB_KEY);
    if (!raw) return null;
    const job = JSON.parse(raw);
    if (!job || !job.jobId || Date.now() - job.startedAt > maxAgeMs) {
      forgetScanJob();
      return null;
    }
    return job.jobId;
  } catch (e) {
    return null;
  }
};
